import { Component, OnInit } from '@angular/core';
import { SuiviSaisieService } from '../suivi-saisie.service';

export interface SuiviVentilationData {
  etape: string;
  nombre: number;
  pourcentage: string;
  filtreEtape: string;
  filtreNiveauErreur: string;
}

export interface SuiviData {
  etape: string;
  nombre: number;
  pourcentage: string;
  filtreEtape: string;
  filtreNiveauErreur: string;
  ventilation: SuiviVentilationData[];
}

@Component({
  selector: 'bis-suivi-general-permanente',
  templateUrl: './suivi-general-permanente.component.html',
  styleUrls: ['./suivi-general-permanente.component.css']
})
export class SuiviGeneralPermanenteComponent implements OnInit {

  suivi: SuiviData[] = [];
  somme: number;
  expandedElement: SuiviData | null;

  constructor(
    private suiviSaisieService: SuiviSaisieService
  ) {
  }

  ngOnInit() {
     this.suiviSaisieService.getSuiviNbRepondant$().subscribe((valeur) => {
      this.suivi = valeur;

      this.somme = this.calculerSomme();
    });
}

  calculerSomme() {
    let somme = 0;
    for (let i = 0; i < this.suivi.length; i++) {
      somme += this.suivi[i].nombre;
    }
    return somme;
  }

  public suiviQuestionnaire (filtreEtape: string, filtreNiveauErreur: string): void {
      // on alimente le parametre selectionné pour l'onglet detail
      this.suiviSaisieService.formulaire.get('etape').setValue(filtreEtape);
      this.suiviSaisieService.formulaire.get('niveauErreur').setValue(filtreNiveauErreur);

      // on bascule sur l'onglet detail
      const nbOnglet = document.getElementsByClassName('mat-mdc-tab').length - 1;
          // tslint:disable-next-line: max-line-length
      this.suiviSaisieService.ongletIndex = this.suiviSaisieService.ongletIndex >= nbOnglet ? nbOnglet : this.suiviSaisieService.ongletIndex + 1;

  }


}

